import { Form, Input } from "decorator-form";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as articleFragments from "../article/fragments";

const articleFragmentInput = FragmentProvider.getLayoutInput(articleFragments);

@Form({title: "Article Panel"})
export default class ArticlePanelConfig {

	@Input({type: articleFragmentInput, title: "Base Article Layout"})
	public layout: ILayout<IFragmentLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/kb/config/ArticlePanelConfig.ts